export default __webpack_public_path__ + "static/media/GenWanMinTW-R-01.5a987da1.woff2";